/**
 * iOS Safari compatible click handler
 * Prevents the blur-before-click issue on iOS Safari
 */

/**
 * Creates event handlers that work reliably on iOS Safari
 * Use this for dropdown triggers and other interactive elements
 * 
 * @param {Function} handler - The function to call when activated
 * @param {Object} options - Optional configuration
 * @returns {Object} - Event handler props to spread on the element
 */
export const createSafeClickHandler = (handler, options = {}) => {
  const { preventDefault = true } = options;
  
  // Track if we handled a touch event to prevent double-firing
  let touchHandled = false;
  
  return {
    onTouchEnd: (e) => {
      if (preventDefault) {
        e.preventDefault();
      }
      touchHandled = true;
      handler(e);
      // Reset after a short delay
      setTimeout(() => { touchHandled = false; }, 300);
    },
    onClick: (e) => {
      // Only fire if not already handled by touch
      if (!touchHandled) {
        if (preventDefault) {
          e.preventDefault();
        }
        handler(e);
      }
    }
  };
};

/**
 * Inline version for JSX - combines onTouchEnd and onClick
 * Usage: {...safeClick(() => setOpen(!open))}
 */
export const safeClick = (handler) => createSafeClickHandler(handler);

export default createSafeClickHandler;
